<template>
  <div class="left-menu-box">
    <div class="menu-button" @click="(menu_flg == true) ? menu_flg = false : menu_flg = true">Ξ</div>
    <div class="main-box" :class="(menu_flg === true) ? 'small-menu' : ''">
      <h1>移動販売・直売所<br>スケジュール管理</h1>
      <div class="menu-box">
        <h2 class="main-box-h2">menu</h2>
        <ul>
          <li><a :class="current_menu(value.status)" v-for="(value, index) in menus" :key="index"><label>{{value.name}}</label></a></li>
        </ul>
        <input type="button" class="sidebar_logout" @click="logout" value="ログアウト" />
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'LeftMenu',
  // ===========================================================================
  // props
  // ===========================================================================
  props: {
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      menus: [
        {name: 'スケジュール', address: 'EditMain', status: 1},
        // {name: 'お知らせ', address: 'InfoMain', status: 2},
      ],
      menu_flg: false,
    };
  },
  computed: {
    status () {
      return this.$store.getters['LoginInfo/menu_status'];
    }
  },
  methods: {
    current_menu (status) {
      return this.status === status ? 'current_menu' : false;
    },
    logout () {
      this.$store.commit('LoginInfo/logout', null);
      location.href = `${this.$DF.BASE_URL}?type=logout`;
    },
  },
};
</script>

<style lang="scss">
.left-menu-box {
  h1 {
    background: #fefefe;
    padding: 5px 0 3px 0;
    text-align: center;
    font-size: 24px;
    color: #6c5a57;
  }
  .menu-box {
    padding: 20px;
  }
  .main-box {
    position: fixed;
    left: 0;
    top: 0;
    font-weight: bold;
    height: 100%;
    z-index: 10;
    overflow: auto;
    width: 240px;
    text-align: left;
    background: #fdf6ce;
    padding: 20px 0 0 0;
  }
  .menu-button {
    width: 50px;
    height: 50px;
    position: fixed;
    right: 10px;
    top: 60px;
    background: #ccc;
    line-height: 3.3;
    font-weight: 800;
    color: #6c5a57;
    // cursor: pointer;
    display: none;
    z-index: 100;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }

  .main-box-h2 {
    font-size: 20px;
    font-weight: bold;
    padding: 0px 0px 8px 0px;
    margin: 0px 0px 0px 0px;
    color: #6c5a57;
  }

  ul {
    li {
      a {
        display: block;
        color: #ab9c9a;
        padding: 11px 10px 9px 10px;
        width: 100%;
        text-decoration: none;
        transition: all 0.2s ease;
        font-size: 14px;

        cursor: pointer;
        label {
          padding: 0 0 0 8px;
          height: 24px;
          line-height: 26px;
          border-left: 6px solid #ab9c9a;
          display: inline-block;
          cursor: pointer;
        }
        &:hover{
          color: #6c5a57;
          label {
            border-left: 6px solid #6c5a57;
          }
        }
      }
      a.current_menu{
        background-color: #fefefe;
        color: #6c5a57;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
        label {
          border-left: 6px solid #6c5a57;
        }
      }
    }
  }

  .sidebar_logout {
      color: #fefefe;
      display: block;
      text-align: center;
      padding: 8px;
      width: 100%;
      font-size: 16px;
      margin: 30px 0px 0px 0px;
      text-decoration: none;
      border-radius: 3px;
  }
}
@media (max-width: 767px) {
  .left-menu-box {
    .main-box {
      left: -300px;
      transition: all 0.3s ease;
    }
    .menu-button {
      top: 5px;
      right: 5px;
      display: block;
    }
    .small-menu {
      left: 0px;
      transition: all 0.3s ease;
    }
  }
}
</style>
